import CheckAffiliateBasedOnLEAndCountry from '../CheckAffiliateBasedOnLEAndCountry';

export const CheckUSAOrCanadaAffiliate = (country: string = ''): boolean => {
    const countryList: string[] = ['USA', 'CAN'];

    if (country !== '') {
        return countryList.includes(country)
    }
    
    return CheckAffiliateBasedOnLEAndCountry(countryList);
};